const indexItems = [
  { letter: 'A', title: '《暗杀风暴》系列深度解析', desc: '邱礼涛导演犯罪动作三部曲全面回顾', tag: '电影评分' },
  { letter: 'B', title: '巴黎电影节华语力量', desc: '历年入围作品全记录与获奖盘点', tag: '独家追踪' },
  { letter: 'C', title: '春节档票房十年变迁', desc: '从《西游降魔》到《流浪地球》，数据全解读', tag: '票房黑马' },
  { letter: 'D', title: '导演新势力图谱', desc: '80后华语导演作品风格与市场表现总览', tag: '幕后花絮' },
  { letter: 'F', title: '翻拍电影的得与失', desc: '中日韩互相翻拍经典作品的成败分析', tag: '争议事件' },
  { letter: 'H', title: '好莱坞中国资本退潮', desc: '从巅峰500亿到归零，五年外资撤退全记录', tag: '八卦揭秘' },
  { letter: 'J', title: '经典港片修复计划', desc: '4K修复版《英雄本色》《阿飞正传》上映日历', tag: '电影上映' },
  { letter: 'M', title: '漫威DC中国市场对比', desc: '超级英雄电影在华票房与口碑演变趋势', tag: '电影评分' },
  { letter: 'S', title: '暑期档观影指南', desc: '2026暑期档全部新片排期与推荐指数一览', tag: '独家追踪' },
];

export default function IndexSection() {
  return (
    <section id="index" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-4">
            影视专题索引
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
            按字母索引浏览覆盖电影上映、幕后花絮、明星动态的全领域专题
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {indexItems.map((item, i) => (
              <a
                key={i}
                href="#hero"
                className="group flex gap-4 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 rounded-xl bg-accent-100 flex items-center justify-center">
                  <span className="text-lg md:text-xl font-heading font-bold text-accent-600">{item.letter}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">{item.desc}</p>
                  <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-semibold">
                    {item.tag}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}